/**
 * Script per aggiornare la data di nascita quando un customer compila la form newsletter
 * Versione compatibile con script iubenda che intercetta il click sul pulsante
 */

(function() {
    'use strict';

    const API_ENDPOINT = 'https://app.massimosantini.com/dob/api/update_birthdate.php';
    const DEBUG = false; 

    /**
     * Log di debug
     */
    function log(message, data) {
        if (DEBUG) {
            console.log('[Newsletter Birthdate]', message, data || '');
        }
    }

    /**
     * Trova il campo email nella form
     */
    function findEmailInput(form) {
        const selectors = [
            'input[type="email"]',
            'input[name*="email" i]',
            'input[id*="email" i]'
        ];

        for (let selector of selectors) {
            const input = form.querySelector(selector);
            if (input && input.value) {
                return input;
            }
        }

        return null;
    }

    /**
     * Trova il campo data di nascita nella form
     * Supporta anche name="contact[note][Birthdate]"
     */
    function findBirthdateInput(form) {
        const selectors = [
            'input[type="date"]',
            'input[name*="birthdate" i]',
            'input[name*="birth_date" i]',
            'input[name*="note" i][type="date"]',
            'input[id*="birthdate" i]',
            'input[id*="birth_date" i]'
        ];

        for (let selector of selectors) {
            const input = form.querySelector(selector);
            if (input && input.value) {
                log('Campo data trovato:', selector, input.name);
                return input;
            }
        }

        // Cerca anche con name che contiene "note" e "Birthdate"
        const allDateInputs = form.querySelectorAll('input[type="date"]');
        for (let input of allDateInputs) {
            if (input.name && (input.name.toLowerCase().includes('birthdate') || 
                               input.name.toLowerCase().includes('note'))) {
                log('Campo data trovato tramite name:', input.name);
                return input;
            }
        }

        return null;
    }

    /**
     * Formatta la data come YYYY-MM-DD
     */
    function formatDate(dateValue) {
        if (!dateValue) return null;

        // Se è già in formato YYYY-MM-DD, restituiscilo
        if (/^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
            return dateValue;
        }

        // Prova a parsare come Date
        const date = new Date(dateValue);
        if (isNaN(date.getTime())) {
            return null;
        }

        // Formatta come YYYY-MM-DD
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }

    /**
     * Chiama l'API per aggiornare la data di nascita
     */
    async function updateBirthdate(email, birthdate) {
        try {
            log('Chiamata API:', { email, birthdate });

            const response = await fetch(API_ENDPOINT, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: email,
                    birthdate: birthdate
                })
            });

            const result = await response.json();

            if (response.ok && result.success) {
                log('API chiamata con successo:', result);
                return { success: true, result: result };
            } else {
                log('API restituito errore:', result);
                return { success: false, error: result.error || 'Errore sconosciuto' };
            }
        } catch (error) {
            log('Errore nella chiamata API:', error);
            return { success: false, error: error.message || 'Errore di connessione' };
        }
    }

    /**
     * Estrae email e data di nascita dalla form e chiama l'API
     */
    async function processFormData(form) {
        // Trova i campi
        const emailInput = findEmailInput(form);
        const birthdateInput = findBirthdateInput(form);

        // Se non c'è il campo email, non fare nulla
        if (!emailInput || !emailInput.value) {
            log('Campo email non trovato o vuoto');
            return false;
        }

        const email = emailInput.value.trim();

        // Se non c'è il campo data di nascita o è vuoto, non fare nulla
        if (!birthdateInput || !birthdateInput.value) {
            log('Campo data di nascita non trovato o vuoto');
            return false;
        }

        const birthdate = formatDate(birthdateInput.value);

        if (!birthdate) {
            log('Data di nascita non valida:', birthdateInput.value);
            return false;
        }

        log('Dati trovati:', { email, birthdate });

        // Chiama l'API (non aspettiamo il risultato per non bloccare il submit)
        updateBirthdate(email, birthdate).then(result => {
            if (result.success) {
                log('Data di nascita aggiornata con successo');
            } else {
                log('Errore nell\'aggiornamento:', result.error);
            }
        }).catch(error => {
            log('Errore nella chiamata API:', error);
        });

        return true;
    }

    /**
     * Gestisce il click sul pulsante submit
     * Questo intercetta anche gli script che usano button.addEventListener('click')
     */
    function handleButtonClick(event) {
        const button = event.target;
        const form = button.closest('form');
        
        if (!form) return;

        log('Click sul pulsante submit intercettato');
        
        // Processa i dati (non blocca il click)
        processFormData(form);
        
        // Non preveniamo il click, lasciamo che l'altro script lo gestisca
    }

    /**
     * Gestisce il submit della form
     */
    function handleFormSubmit(event) {
        const form = event.target;
        log('Submit della form intercettato');
        
        // Processa i dati (non blocca il submit)
        processFormData(form);
        
        // Non preveniamo il submit, lasciamo che proceda normalmente
    }

    /**
     * Inizializza lo script quando il DOM è pronto
     */
    function init() {
        // Aspetta che il DOM sia caricato
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', init);
            return;
        }

        log('Inizializzazione script newsletter-birthdate');

        // Trova tutte le form newsletter
        const forms = document.querySelectorAll('form[data-newsletter-form], form.newsletter-form, form[action*="/contact"]');

        forms.forEach(function(form) {
            if (form.hasAttribute('data-birthdate-handler')) {
                log('Form già gestita, skip');
                return;
            }

            form.setAttribute('data-birthdate-handler', 'true');
            log('Form trovata e gestita:', form.id || form.className);

            // Intercetta sia il submit che il click sul pulsante
            form.addEventListener('submit', handleFormSubmit, true); // useCapture = true per intercettare prima
            
            // Intercetta anche i click sui pulsanti submit
            const submitButtons = form.querySelectorAll('button[type="submit"], input[type="submit"]');
            submitButtons.forEach(function(button) {
                // Usa capture phase per intercettare prima degli altri script
                button.addEventListener('click', handleButtonClick, true);
                log('Event listener aggiunto al pulsante:', button.id || button.className);
            });
        });

        // Se la form viene aggiunta dinamicamente dopo il caricamento
        const observer = new MutationObserver(function(mutations) {
            const newForms = document.querySelectorAll('form[data-newsletter-form], form.newsletter-form, form[action*="/contact"]');
            newForms.forEach(function(form) {
                if (!form.hasAttribute('data-birthdate-handler')) {
                    form.setAttribute('data-birthdate-handler', 'true');
                    form.addEventListener('submit', handleFormSubmit, true);
                    
                    const submitButtons = form.querySelectorAll('button[type="submit"], input[type="submit"]');
                    submitButtons.forEach(function(button) {
                        button.addEventListener('click', handleButtonClick, true);
                    });
                    
                    log('Nuova form trovata e gestita');
                }
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    // Avvia l'inizializzazione
    init();

})();